import script from "./Parcela.vue?vue&type=script&setup=true&lang=ts"
export * from "./Parcela.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__